const defaultCustomerParams = {
    isLoggedIn: true,
    onePass: {
        club: {
            active: false,
            freeTrialEligible: true,
            onFreeTrial: false,
        },
        membership: {
            id: "1",
            linked: true,
            doubleSubscription: false,
            eligibleForMigration: false,
            subscription: {
                active: false,
                freeTrialEligible: false,
                freeTrialDaysRemaining: 30,
                onFreeTrial: false,
            },
        },
    },
};
export const buildMockCustomer = ({ isLoggedIn = true, onePass: { club, membership }, } = defaultCustomerParams) => {
    if (!isLoggedIn) {
        return null;
    }
    return {
        __typename: "Customer",
        id: "1234",
        displayName: "Joe",
        email: "joe@catch.com.au",
        club: club !== null
            ? {
                __typename: "ClubCustomerSubscription",
                ...defaultCustomerParams.onePass.club,
                ...club,
            }
            : null,
        membership: membership !== null
            ? {
                ...defaultCustomerParams.onePass.membership,
                ...membership,
                subscription: {
                    ...defaultCustomerParams.onePass.membership.subscription,
                    ...membership.subscription,
                },
            }
            : null,
        storeCredit: {
            credit: {
                amount: 20,
            },
            expiry: "2024-05-18T13:59:59.000Z",
        },
        metaData: {
            customerUuid: "e2e51708-588c-41da-8e2a-b8b2de8ac62e",
        },
    };
};
export const mockCustomer = buildMockCustomer();
